var login = {
  translation: {
    common: {
      accept: 'Akzeptieren',
      alreadyUser: 'Bereits ein Nutzer?',
      and: 'und',
      backToLogin: 'Zurück zur Anmeldeseite',
      continueWith: 'Fortfahren mit {{provider}}',
      createAccount: 'Konto erstellen',
      createYourAccount: 'Erstelle dein Konto',
      emailOrUsername: 'E-Mail oder Benutzername',
      login: 'Einloggen',
      logInToBoards: 'Einloggen',
      newToBoards: 'Neu bei RICE-WORK?',
      pageNotFound_title: 'Seite nicht gefunden',
      password: 'Passwort',
      privacyPolicy: 'Datenschutzerklärung',
      register: 'Registrieren',
      registerWithGoogle: 'Mit Google registrieren',
      termsOfService: 'Nutzungsbedingungen',
      togglePasswordVisibility: 'Passwort-Sichtbarkeit umschalten',
    },

    action: {
      logIn: 'Einloggen',
    },
  },
};

export { login as default };
